module.exports = __webpack_public_path__ + "img/type.5021c0bc.svg";